import { dateTimeReviver } from '@app/util/revive-dates';

export function deserializerWithDateReviver({ data }: MessageEvent): any {
  return JSON.parse(data, dateTimeReviver);
}
